import { useCallback, useEffect } from "react";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import SearchParams from "simplydo/core/searchParams";
import { OpenAPI } from "simplydo/interfaces";

import actions from "actions";
import api from "api";

import MessageMole from "./MessageMole";

type MessageMolesContainerProps = {
  selectedMessageThreads: OpenAPI.Schemas["MessageThread"][];
};

const MessageMolesContainer = ({
  selectedMessageThreads,
}: MessageMolesContainerProps) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const onMessageThreadSelected = useCallback(
    (thread: OpenAPI.Schemas["MessageThread"]) =>
      dispatch(actions.messages.selectThread(thread)),
    [dispatch],
  );

  useEffect(() => {
    const searchParams = new SearchParams(location.search);
    if (searchParams.has("threadId")) {
      const threadId = searchParams.get("threadId") as string;
      api.messages.getThread(
        threadId,
        ({ thread }) => {
          onMessageThreadSelected(thread);
        },
        () => {},
      );

      // Remove the threadId from the URL after opening
      searchParams.delete("threadId");
      const stringifiedParams = searchParams.toString();
      window.history.replaceState(
        {},
        "",
        location.pathname + (stringifiedParams ? `?${stringifiedParams}` : ""),
      );
    }
  }, [location, onMessageThreadSelected]);

  return (
    <>
      {selectedMessageThreads.map((t, index) => (
        <MessageMole
          thread={t}
          index={index}
          key={t._id}
          totalThreads={selectedMessageThreads.length}
        />
      ))}
    </>
  );
};

export default MessageMolesContainer;
